import type { Path } from "@/router";
import type { MetricCardType } from "@/components/MetricCard/MetricCard.types";
import MetricGrid from "@/components/MetricGrid";
import SectionHeading from "@/components/SectionHeading";

import type { CareerPlanCompetencyScore } from "./careerPlanHistory";
import { getExperienceIndexGapCopy } from "./experienceIndexCompetencyCopy";
import { getExperienceIndexCompetencyIcon } from "./experienceIndexIcons";
import { getTopGaps, type CareerRoleFit } from "./experienceIndexResults";

const PRIORITY_GAPS_HEADING = {
  heading: "Priority Gaps",
  body: "Where this person has the most room to grow versus this comparison role."
};

const PRIORITY_GAPS_EMPTY_COPY = "No gaps versus this comparison role right now.";

export default function ExperienceIndexPriorityGapsSection({
  roleFit,
  scores,
  onSelectCompetency
}: {
  roleFit: CareerRoleFit;
  scores: CareerPlanCompetencyScore[];
  onSelectCompetency?: (competencyId: string) => void;
}) {
  const gaps = getTopGaps(roleFit, scores);
  const metrics: MetricCardType<Path>[] = gaps.map((gap) => ({
    iconName: getExperienceIndexCompetencyIcon(gap.competencyName),
    value: gap.competencyName,
    label: getExperienceIndexGapCopy(gap.competencyName),
    testId: `career-plan-priority-gap-${gap.competencyId}`,
    asButton: Boolean(onSelectCompetency),
    onClick: onSelectCompetency ? () => onSelectCompetency(gap.competencyId) : undefined
  }));

  return (
    <div data-testid="career-plan-priority-gaps">
      <SectionHeading heading={PRIORITY_GAPS_HEADING.heading} body={PRIORITY_GAPS_HEADING.body} />
      {metrics.length > 0 ? (
        <MetricGrid metrics={metrics} layout="compact" hasHeading />
      ) : (
        <p className="text-body-medium text-sys-brand-on-surface-variant" data-testid="career-plan-priority-gaps-empty">
          {PRIORITY_GAPS_EMPTY_COPY}
        </p>
      )}
    </div>
  );
}
